var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 9" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M7.68 7.68a.91.91 0 0 1-1.29 0L4.5 5.79 2.61 7.68a.91.91 0 1 1-1.29-1.29L3.21 4.5 1.32 2.61a.91.91 0 0 1 1.29-1.29L4.5 3.21l1.89-1.89a.91.91 0 1 1 1.29 1.29L5.79 4.5l1.89 1.89a.91.91 0 0 1 0 1.29z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Deleted.svg